import React, {useRef, useState, useEffect, useRef as useRefAlias} from 'react'
import {useMutation, useQueryClient} from 'react-query'
import {KTSVG} from '../../../_metronic/helpers'
import {importPricings} from './PricesFunctions'

export default function ImportButton({ accessToken, gateType }) {
  const inputRef = useRef(null)
  const queryClient = useQueryClient()

  const [successVisible, setSuccessVisible] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const timerRef = useRefAlias(null)

  useEffect(() => {
    return () => { if (timerRef.current) clearTimeout(timerRef.current) }
  }, [])

  const mutation = useMutation(
    ({ file }) => importPricings(accessToken, file, { gateTypeId: gateType, overwrite: true }),
    {
      onSuccess: async () => {
        if (timerRef.current) clearTimeout(timerRef.current)
        setErrorMsg('')
        setSuccessVisible(true)

        await queryClient.invalidateQueries(['pricing'])

        queryClient.refetchQueries(['pricing'], { active: true })

        timerRef.current = setTimeout(() => setSuccessVisible(false), 1000)
      },
      onError: (err) => {
        if (timerRef.current) clearTimeout(timerRef.current)
        setSuccessVisible(false)
        setErrorMsg(err?.message || 'Coś poszło nie tak')
        timerRef.current = setTimeout(() => setErrorMsg(''), 4000)
      },
    }
  )

  if (!gateType || gateType === 'nogate') return null

  const handlePickFile = () => {
    if (mutation.isLoading) return
    inputRef.current?.click()
  }

  const handleFileChange = (e) => {
    const file = e.target.files?.[0]
    if (!file) return

    const okExt = /\.csv$|\.xlsx$/i.test(file.name)
    if (!okExt) {
      setSuccessVisible(false)
      setErrorMsg('Dozwolone pliki: .csv lub .xlsx')
      if (timerRef.current) clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => setErrorMsg(''), 4000)
      e.target.value = ''
      return
    }

    mutation.mutate({ file })
    e.target.value = ''
  }

  return (
    <div className="position-relative d-inline-block">
      <input
        ref={inputRef}
        type="file"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />

      <button
        onClick={handlePickFile}
        disabled={mutation.isLoading}
        className="btn btn-sm btn-light-success"
      >
        <KTSVG path="/media/icons/duotune/arrows/arr067.svg" className="svg-icon-3 me-2" />
        {mutation.isLoading ? 'Importuję...' : 'Importuj cennik'}
      </button>


      <div
        className="position-absolute start-0 w-100 text-center"
        style={{ top: '100%', marginTop: 6, pointerEvents: 'none' }}
        aria-live="polite"
      >
        {successVisible && (
          <span className="badge badge-light-success fw-bold">Import zakończony</span>
        )}
        {errorMsg && (
          <span className="badge badge-light-danger fw-bold">{errorMsg}</span>
        )}
      </div>
    </div>
  )
}
